import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useEffect } from 'react';
import { AddLinkButton, Section } from '../Shared';
import { TestIds } from './constants';
import { Contributor } from './Contributor';
import { useFormikContext } from 'formik';
import { getDefaultContributorState } from './helpers';
export var SECTION_ID = 'contributor-section';
export var ContributorSection = function ContributorSection(_ref) {
  var functionOptions = _ref.functionOptions;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    if (!values.contributors || Array.isArray(values.contributors) && values.contributors.length === 0) {
      setFieldValue('contributors', [getDefaultContributorState(functionOptions)]);
    }
  }, [setFieldValue, functionOptions, values]);

  /** all the actions for contributor section */
  var addContributor = function addContributor() {
    var _values$contributors;
    var prevContributors = (_values$contributors = values.contributors) !== null && _values$contributors !== void 0 ? _values$contributors : [];
    setFieldValue('contributors', [].concat(_toConsumableArray(prevContributors), [getDefaultContributorState(functionOptions)]));
  };
  var removeContributorAtIndex = function removeContributorAtIndex(index) {
    var _values$contributors2;
    if (((_values$contributors2 = values.contributors) === null || _values$contributors2 === void 0 ? void 0 : _values$contributors2.length) === 1) {
      setFieldValue('contributors', [getDefaultContributorState(functionOptions)]);
    } else {
      var _values$contributors3;
      var prevContributors = (_values$contributors3 = values.contributors) !== null && _values$contributors3 !== void 0 ? _values$contributors3 : [];
      setFieldValue('contributors', [].concat(_toConsumableArray(prevContributors.slice(0, index)), _toConsumableArray(prevContributors.slice(index + 1))));
    }
  };
  function renderContributors() {
    if (values.contributors) {
      return values.contributors.map(function (contributor, index) {
        return /*#__PURE__*/React.createElement(Contributor, {
          key: index,
          index: index,
          functionOptions: functionOptions,
          removeContributor: function removeContributor() {
            return removeContributorAtIndex(index);
          }
        });
      });
    }
  }
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: "Contributors",
    ariaLabelledby: "contributor-section-label",
    dataTestId: TestIds.CONTRIBUTOR_SECTION
  }, renderContributors(), /*#__PURE__*/React.createElement(AddLinkButton, {
    "data-test": TestIds.ADD_CONTRIBUTOR_LINK,
    label: "Add another contributor",
    onClick: addContributor
  }));
};